"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SABRE_MANUFACTURER_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.SABRE_MANUFACTURER_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment Manufacturer on Manufacturer {\n    id\n    name\n  }\n"], ["\n  fragment Manufacturer on Manufacturer {\n    id\n    name\n  }\n"])));
var templateObject_1;
